var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 11.4844C27.2812 10.7344 26.7188 9.75 25.8281 9.75H7.125C6.14062 9.75 4.96875 10.4531 4.5 11.25L1.125 17.0625C0.65625 17.8125 1.21875 18.75 2.10938 18.75H20.8125C21.7969 18.75 22.9688 18.0938 23.4375 17.2969L26.8125 11.4844ZM7.125 8.25H22.5V6C22.5 4.78125 21.4688 3.75 20.25 3.75H12.75L9.75 0.75H2.25C0.984375 0.75 0 1.78125 0 3V16.0781L3.23438 10.5C4.03125 9.14062 5.48438 8.25 7.125 8.25Z",
    fill: "#2D5049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenSelected);
export default __webpack_public_path__ + "static/media/folder-open-selected.df605056bc5637929072e9485169b290.svg";
export { ForwardRef as ReactComponent };